import React from 'react';
import { Layout1 } from '../../../../layout';

import { ApiWrapper } from './api-wrapper';

const OrderHistory = () => (
  <Layout1
    mainContent={
      <div>
        <ApiWrapper />
      </div>
    }
  />
);

export default OrderHistory;
